import { Box, Progress } from '@chakra-ui/react';
import React, { useEffect, useState } from 'react';
import CustomProgress from '../../common/CustomProgress';
import { Text } from '@chakra-ui/react';
interface Props {
	setCurrentStep: React.Dispatch<React.SetStateAction<number>>;
	currentStep: number;
}
const ProgressHeader = ({ setCurrentStep, currentStep }: Props) => {
	const progressValue = {
		1: 0,
		2: 25,
		3: 50,
		4: 75,
	};

	const totalSteps = 4;
	// Simulate progress update
	useEffect(() => {
		//
	}, [progressValue]);

	return (
		<Box py="24px">
			<Box mb="3px" display={'flex'} justifyContent={'space-between'}>
				<Text color="#6C6768" fontSize={'12px'} fontWeight={600} textStyle="body2-md">
					Progress
				</Text>
				<Box>
					<Text color="#4358F6" display={'inline'} fontSize={'12px'} fontWeight={600} textStyle="body2-md">
						{currentStep}{' '}
						<Text display={'inline'} color="#0A0103" fontSize={'12px'} fontWeight={600} textStyle="body2-md">
							/ {totalSteps}
						</Text>
					</Text>
				</Box>
			</Box>
			{
				// @ts-ignore
				<CustomProgress value={progressValue[currentStep]} max={100} />
			}
		</Box>
	);
};

export default ProgressHeader;
